import { useEffect } from 'react';
import { CreditBureau } from './creditBureau/CreditBureau';
import { LOAD_CB_VERSION } from './constants';
import { HostEnvironment, hostUrlHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

const CreditBureauActivity = () => {
    const environment = hostUrlHelper.getHostUrlEnvironment(MANAGER_VIEW_APP_PREFIX, locHrefUtil.getLocHref());

    useEffect(() => {
        const scriptAlpha = document.createElement('script');
        const version = LOAD_CB_VERSION;
        scriptAlpha.src = `https://${
            environment === HostEnvironment.Prod ? 'fni-static' : 'fni-static-np'
        }.dealertrack.com/apps/fni-credit-bureau-widget/versions/${version}/fni-credit-bureau.esm.js`;
        scriptAlpha.type = 'module';
        scriptAlpha.id = 'fni-cb-module';
        document.body.appendChild(scriptAlpha);

        const scriptBeta = document.createElement('script');
        scriptBeta.src = `https://${
            environment === HostEnvironment.Prod ? 'fni-static' : 'fni-static-np'
        }.dealertrack.com/apps/fni-credit-bureau-widget/versions/${version}/fni-credit-bureau.js`;
        scriptBeta.noModule = true;
        scriptBeta.id = 'fni-cb-js';
        document.body.appendChild(scriptBeta);
        return () => {
            const cbScripts = document.querySelectorAll('script[id*="fni-cb-"]');
            cbScripts.forEach((elem) => elem.remove());
        };
    }, []);

    return <CreditBureau />;
};

export default CreditBureauActivity;
